//license address editor module
import { get, post } from "@/vue/api/api";

import Vue from "vue";

export const lae = {
  state: {
    unassignedLicenses: [],
    siteAddresses: [],
    laeUpdateResult: {},
  },
  getters: {
    getUnassignedLicenses: (state) => {
      return state.unassignedLicenses;
    },
    getSiteAddresses: (state) => {
      return state.siteAddresses;
    },
    getLeaUpdateResults: (state) => {
      return state.laeUpdateResult;
    },
  },
  mutations: {
    SET_UNASSIGNED_LICENSES: (state, payload) => {
      state.unassignedLicenses = payload;
    },
    SET_SITE_ADDRESSES: (state, payload) => {
      state.siteAddresses = payload;
    },
    SET_LAE_UPDATE_RESULT: (state, payload) => {
      state.laeUpdateResult = payload;
    },
  },
  actions: {
    fetchUnassignedLicenses: ({ commit, rootGetters }, payload) => {
      get("v1/licenses/unassigned")
        .then((response) => {
          console.log("fetchUnassignedLicenses response");
          console.log(response);

          commit(
            "SET_UNASSIGNED_LICENSES",
            Vue.lodash.reduce(
              response.data,
              (acc, item) => {
                if (item.serviceAddress && item.serviceAddress.freeForm) {
                  let license = Vue.lodash.pick(item, [
                    "isSuspended",
                    "licenseId",
                    "licensePoolId",
                    "skuDesc",
                    "name",
                    "referenceId",
                    "status",
                    "phoneNumber",
                    "serviceOwner",
                    "suspendReason",
                  ]);
                  if (!license.hasOwnProperty("referenceId"))
                    license.referenceId = "";
                  if (!license.hasOwnProperty("status")) license.status = "";
                  if (!license.hasOwnProperty("phoneNumber"))
                    license.phoneNumber = "";
                  if (!license.hasOwnProperty("serviceOwner"))
                    license.serviceOwner = "";
                  license.serviceAddress = item.serviceAddress.freeForm;
                  license.newAddress = "";
                  license.isSuspended = license.isSuspended ? "Yes" : "No";
                  acc.push(license);
                }
                return acc;
              },
              []
            )
          );
          if (payload.success) {
            payload.success(response.message);
          }
        })
        .catch((error) => {
          console.log("fetchUnassignedLicenses error");
          console.log(error.message || error);
          if (payload.error) {
            payload.error(error.message);
          }
        });
    },
    fetchSiteAddresses: ({ commit, rootGetters }, payload) => {
      get("v1/sites/address")
        .then((response) => {
          console.log("fetchSiteAddresses response");

          commit(
            "SET_SITE_ADDRESSES",
            Vue.lodash.uniqBy(
              Vue.lodash.map(response.data, (item) => {
                return item.emergencyAddress;
              }),
              "freeForm"
            )
          );

          if (payload && payload.success) {
            payload.success(response);
          }
        })
        .catch((error) => {
          console.log("fetchSiteAddresses error");
          console.log(error.message || error);
          if (payload && payload.error) {
            payload.error(error.message);
          }
        });
    },
    updateSiteAddress: ({ commit, dispatch, rootGetters }, payload) => {
      post("v1/licenses/address", payload.data)
        .then((response) => {
          console.log("updateSiteAddress response");
          console.log(response);
          commit("SET_LAE_UPDATE_RESULT", response.data);
          if (payload && payload.success) {
            payload.success(response);
            dispatch("sendAudit", {
              eventType: "UPDATE",
              objectType: "Licenses address editor",
              details: payload.data,
            });
          }
        })
        .catch((error) => {
          console.log("updateSiteAddress error");
          console.log(error.message || error);
          if (payload && payload.error) {
            payload.error(error.message);
          }
        });
    },
  },
};
